import { render, staticRenderFns } from "./google.page.vue?vue&type=template&id=7197ae3a&"
import script from "./google.page.vue?vue&type=script&lang=js&"
export * from "./google.page.vue?vue&type=script&lang=js&"
import style0 from "./google.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports